import Routes from "@navigations/Routes";
import { navigate } from "@navigations/utils/RootNavigation";
import { ProductCategory } from "@utils/constants";
import { TFunction } from "i18next";
import { DefaultTheme } from "styled-components/native";

export const actionFunctions = (
  action: string,
  naturalDiamondsData: any,
  labGrownDiamondsData: any,
  coloredGemstonesData: any,
  jewelryData: any
) => {
  switch (action) {
    case "natural_daimonds":
      if (naturalDiamondsData?.length > 0 && naturalDiamondsData[0] !== 0) {
        navigate(Routes.ProductSearchGroupScreen, {
          searchGroupsData: naturalDiamondsData,
          productType: ProductCategory.DIAMOND,
        });
      }
      break;
    case "lab_grown_daimonds":
      if (labGrownDiamondsData?.length > 0 && labGrownDiamondsData[0] !== 0) {
        navigate(Routes.ProductSearchGroupScreen, {
          searchGroupsData: labGrownDiamondsData,
          productType: ProductCategory.LAB_GROWN_DIAMOND,
        });
      }
      break;
    case "colored_gemstones":
      if (coloredGemstonesData?.length > 0 && coloredGemstonesData[0] !== 0) {
        navigate(Routes.ProductSearchGroupScreen, {
          searchGroupsData: coloredGemstonesData,
          productType: ProductCategory.GEMSTONE,
        });
      }
      break;
    case "jewelry":
      if (jewelryData?.length > 0 && jewelryData[0] !== 0) {
        navigate(Routes.ProductSearchGroupScreen, {
          searchGroupsData: jewelryData,
          productType: ProductCategory.JEWELRY,
        });
      }
      break;
    default:
      break;
  }
};

export const rightIconFunction = (
  rightIconTheme: string,
  naturalDiamondsData: any,
  labGrownDiamondsData: any,
  coloredGemstonesData: any,
  jewelryData: any,
  theme: DefaultTheme
) => {
  switch (rightIconTheme) {
    case "diamond":
      if (naturalDiamondsData?.length > 0 && naturalDiamondsData[0] !== 0) {
        return theme["core-04"];
      } else {
        return theme["core-01"];
      }

    case "lab_grown":
      if (labGrownDiamondsData?.length > 0 && labGrownDiamondsData[0] !== 0) {
        return theme["core-04"];
      } else {
        return theme["core-01"];
      }

    case "gemstones":
      if (coloredGemstonesData?.length > 0 && coloredGemstonesData[0] !== 0) {
        return theme["core-04"];
      } else {
        return theme["core-01"];
      }

    case "jewelry":
      if (jewelryData?.length > 0 && jewelryData[0] !== 0) {
        return theme["core-04"];
      } else {
        return theme["core-01"];
      }
  }
};

export const getHeaderTitle = (
  productType: string,
  t: TFunction<"translation", undefined>
) => {
  switch (productType) {
    case "diamond":
      return t("searchGroup.naturalDiamonds.title.text");
    case "lab_grown_diamond":
      return t("searchGroup.labGrownDiamonds.title.text");
    case "gemstone":
      return t("searchGroup.coloredGemstonesDiamonds.title.text");
    case "jewelry":
      return t("searchGroup.jewelry.title.text");
    default:
      return t("searchGroup.title.text");
  }
};

export const sortGroupsByProductType = (SearchGroupData) => {
  let diamond = [0];
  let lab_grown_diamond = [0];
  let gemstone = [0];
  let jewelry = [0];

  const groups = SearchGroupData?.data?.data?.groups;

  groups?.forEach((group) => {
    group.product_types.forEach((productType) => {
      switch (productType) {
        case "0":
          if (diamond[0] === 0) diamond.shift();
          diamond.push(group);
          break;
        case "1":
          if (lab_grown_diamond[0] === 0) lab_grown_diamond.shift();
          lab_grown_diamond.push(group);
          break;
        case "2":
          if (gemstone[0] === 0) gemstone.shift();
          gemstone.push(group);
          break;
        case "3":
          if (jewelry[0] === 0) jewelry.shift();
          jewelry.push(group);
          break;
        default:
          break;
      }
    });
  });

  return {
    diamond: diamond,
    lab_grown_diamond: lab_grown_diamond,
    gemstone: gemstone,
    jewelry: jewelry,
  };
};

export const sortIdsByProductType = (SearchGroupData) => {
  let diamond = [0];
  let lab_grown_diamond = [0];
  let gemstone = [0];
  let jewelry = [0];

  const groups = SearchGroupData?.data?.data?.groups;

  groups?.forEach((group) => {
    group.product_types.forEach((productType) => {
      switch (productType) {
        case "0":
          if (diamond[0] === 0) diamond.shift();
          diamond.push(group.id);
          break;
        case "1":
          if (lab_grown_diamond[0] === 0) lab_grown_diamond.shift();
          lab_grown_diamond.push(group.id);
          break;
        case "2":
          if (gemstone[0] === 0) gemstone.shift();
          gemstone.push(group.id);
          break;
        case "3":
          if (jewelry[0] === 0) jewelry.shift();
          jewelry.push(group.id);
          break;
        default:
          break;
      }
    });
  });

  return {
    diamond: diamond,
    lab_grown_diamond: lab_grown_diamond,
    gemstone: gemstone,
    jewelry: jewelry,
  };
};

export const getGroupName = (selectedGroups: any, otherGroups: any) => {
  if (selectedGroups?.length === 1) {
    const selectedId = selectedGroups[0];
    const GroupName = otherGroups.find((id) => id.id === selectedId);
    if (GroupName) {
      return GroupName.name.substring(0, 3);
    }
  }
  return null;
};

export const selectedGroupName = (
  selectedGroups: any,
  otherGroups: any,
  productTypes: any
) => {
  const availableProductTypes = productTypes[0].data.map(
    (section: any) => section.key
  );
  const filteredSelectedGroups = Object.fromEntries(
    Object.entries(selectedGroups).filter(([key]) =>
      availableProductTypes.includes(key)
    )
  );

  const allGroupIds = Object.values(filteredSelectedGroups);
  const commonIds = allGroupIds.reduce((common, ids) => {
    return common.filter((id) => ids.includes(id));
  }, allGroupIds[0]);

  const groupCommonIds = commonIds.filter((id) => {
    return Object.keys(filteredSelectedGroups)?.every((key) => {
      const groupIds = filteredSelectedGroups[key];
      return groupIds.length === 1 && groupIds[0] === id;
    });
  });

  if (groupCommonIds.length === 1) {
    const commonId = groupCommonIds[0];
    for (const key in otherGroups) {
      const group = otherGroups[key].find((id) => id.id === commonId);
      if (group) {
        return group.name.substring(0, 3);
      }
    }
  } else if (
    Object.values(filteredSelectedGroups).some(
      (arr: any) => !(arr as number[]).includes(0)
    )
  ) {
    return "Multiple";
  }

  return "VDB";
};
